/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Teary_Close_Slug_PopInputs */

const fr_teary_close_slug_pop = /** @type {(inputs: Teary_Close_Slug_PopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun exercice trouvé`)
};

/**

* @param {Teary_Close_Slug_PopInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const teary_close_slug_pop = /** @type {((inputs?: Teary_Close_Slug_PopInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teary_Close_Slug_PopInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_teary_close_slug_pop(inputs)
});